import React from 'react';
import { Card } from './ui/card';

const IndustriesCovered = () => {
  const industries = [
    {
      name: 'FinTech & Financial Infrastructure',
      insight: 'Growth in regulated environments requires precision—not just scale.',
    },
    {
      name: 'Education & EdTech',
      insight: 'Customer lifetime value and trust are everything; acquisition is just the start.',
    },
    {
      name: 'Marketplaces & Platforms',
      insight: 'Two-sided growth is a different game—supply, demand, and network effects matter.',
    },
    {
      name: 'Media & Content Businesses',
      insight: 'Audience attention is the currency; monetization follows engagement.',
    },
    {
      name: 'Enterprise & B2B Tech',
      insight: 'Long sales cycles and committee buying require patience and precision.',
    },
    {
      name: 'Health, Wellness & Consumer Brands',
      insight: 'Community and authenticity drive retention more than performance ads.',
    },
  ];

  return (
    <section id="industries" className="py-24 px-4 sm:px-6 lg:px-8 bg-slate-900 text-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold mb-4">Industries Covered</h2>
        <p className="text-slate-400 mb-12 max-w-3xl">
          Each industry has its own growth dynamics. Here's what I've learned working across them.
        </p>

        <div className="grid md:grid-cols-2 gap-6">
          {industries.map((industry, index) => (
            <Card key={index} className="p-6 bg-slate-800 border-slate-700">
              <h3 className="text-lg font-semibold text-white mb-2">{industry.name}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{industry.insight}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesCovered;